<template>
    <footer class="footer">
        <b-container fluid>
            <b-row>
                <b-col col sm="12">
                    {{ new Date().getFullYear() }} © AAI FMS.
                </b-col>
                <!-- <b-col col sm="6">
                    <div class="text-sm-end d-none d-sm-block">
                        Design & Develop by AAI IT
                    </div>
                </b-col> -->
            </b-row>
        </b-container>
    </footer>
</template>
